/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TourStatus {
  Open = 'open',
  Sent = 'sent',
  Closed = 'closed'
}
